import React from "react";
import { Marker, Popup } from "react-map-gl";
import { Typography } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Link from "@material-ui/core/Link";
import { useTranslation } from "react-i18next";
import BusinessIcon from "@material-ui/icons/Business";
import ListIcon from "@material-ui/icons/List";

import Pin from "./pin";
import { goToPolicyPage } from "../policy/utils";

export function createMarkers(props, setSelectedPolicy) {
  const date = new Date();
  return (
    props.markers?.length > 0 &&
    props.markers.map((marker, idx) => (
      <Marker key={date + "_" + idx} longitude={marker.cys_lon} latitude={marker.cys_lat}>
        <Pin size={20} onClick={() => setSelectedPolicy(marker)} />
      </Marker>
    ))
  );
}

export function smallPopupBoxCreation(selectedPolicy, setSelectedPolicy, policyCompanyCode) {
  return (
    <Popup
      tipSize={5}
      anchor="top"
      longitude={selectedPolicy.cys_lon}
      latitude={selectedPolicy.cys_lat}
      closeOnClick={false}
      onClose={() => setSelectedPolicy(null)}
    >
      <Box display="flex" alignItems="center" p={1} m={-1}>
        <BusinessIcon />
        <Typography variant="body1" style={{ marginLeft: "8px", cursor: "default" }}>
          {policyCompanyCode}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" p={1} m={-1}>
        <ListIcon />
        <Typography
          variant="body1"
          onClick={() =>
            goToPolicyPage(
              selectedPolicy.policyNumber,
              selectedPolicy.policyNumberSecondary,
              selectedPolicy.multilocationID,
              selectedPolicy.locationStartDate,
            )
          }
          style={{ marginLeft: "8px", cursor: "pointer" }}
        >
          {selectedPolicy.policyNumber}
        </Typography>
      </Box>

      <Box display="flex" alignItems="center" p={1} m={-1}>
        <BusinessIcon />
        <Typography variant="body1" style={{ marginLeft: "8px", cursor: "default" }}>
          {selectedPolicy.multilocationID}
        </Typography>
      </Box>
    </Popup>
  );
}
